export const enum mediaConstants {
  // Upload media (images/videos)
  uploadMediaRequest = "UPLOAD_MEDIA_REQUEST",
  uploadMediaSuccess = "UPLOAD_MEDIA_SUCCESS",
  uploadMediaFailure = "UPLOAD_MEDIA_FAILURE",
  uploadMediaProgress = "UPLOAD_MEDIA_PROGRESS",
  
  // Clear upload state
  clearUploadMediaState = "CLEAR_UPLOAD_MEDIA_STATE",
  
  // Remove file from list
  removeFileFromList = "REMOVE_FILE_FROM_LIST",
  
  // Add files to list
  addFilesToList = "ADD_FILES_TO_LIST",

  listMediaRequest = "LIST_MEDIA_REQUEST",
  listMediaSuccess = "LIST_MEDIA_SUCCESS",
  listMediaFailure = "LIST_MEDIA_FAILURE",

  updateMediaStatusRequest = "UPDATE_MEDIA_STATUS_REQUEST",
  updateMediaStatusSuccess = "UPDATE_MEDIA_STATUS_SUCCESS",
  updateMediaStatusFailure = "UPDATE_MEDIA_STATUS_FAILURE",
}
